/* eslint-disable
  strict,
  no-param-reassign
*/
'use strict';

var _classCallCheck = require("D:\\gwsd_code\\gwsd_h5\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _assertThisInitialized = require("D:\\gwsd_code\\gwsd_h5\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("D:\\gwsd_code\\gwsd_h5\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:\\gwsd_code\\gwsd_h5\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\gwsd_code\\gwsd_h5\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("D:\\gwsd_code\\gwsd_h5\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ValidationError = /*#__PURE__*/function (_Error) {
  _inherits(ValidationError, _Error);

  var _super = _createSuper(ValidationError);

  function ValidationError(errors, name) {
    var _this;

    _classCallCheck(this, ValidationError);

    _this = _super.call(this);
    _this.name = 'ValidationError';
    _this.message = "".concat(name || '', " Invalid Options\n\n");
    _this.errors = errors.map(function (err) {
      err.dataPath = err.dataPath.replace(/\//g, '.');
      return err;
    });

    _this.errors.forEach(function (err) {
      _this.message += "options".concat(err.dataPath, " ").concat(err.message, "\n");
    });

    Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    return _this;
  }

  return ValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

module.exports = ValidationError;